module.exports = {
  en: {
    // CATEGORIES

    // TAGS
    'twice': 'https://viki.rakutenimageorigin.com/image/e940979046a2450fbe69e51e803a7d65.jpeg', // TWICE
    'gfriend': 'https://viki.rakutenimageorigin.com/image/c265dca22caa4795bd4cdc5aeb8d6000.jpeg', // GFriend
    'exo': 'https://viki.rakutenimageorigin.com/image/187a3ec0d43244eb81273a52b93ec74a.jpeg', // EXO
    'bts': 'https://viki.rakutenimageorigin.com/image/f3a93453d47649a291cdecc8b908682b.jpeg', // BTS
    'got7': 'https://viki.rakutenimageorigin.com/image/79e6ebd5b73445a4951fd992a245c5bc.jpeg', // GOT7
    'bigbang': 'https://viki.rakutenimageorigin.com/image/2b2e648acf4b4af38e0bcd5bcb6cdda6.jpeg', // BIGBANG
    'winner': 'https://viki.rakutenimageorigin.com/image/9207dc38be544b829d1d849aac7d7bd1.jpeg', // WINNER
    'red-velvet': 'https://viki.rakutenimageorigin.com/image/6e6be0d9663f4be79de67e8f0ccd730e.jpeg', // Red Velvet
    'super-junior': 'https://viki.rakutenimageorigin.com/image/ee3bc7a447f740c5a2a301b214d82bef.jpeg', // Super Junior
    'wanna-one': 'https://viki.rakutenimageorigin.com/image/1244bef2b85043dbbc75efc28c89aa32.jpeg', // Wanna One
    'blackpink': 'https://viki.rakutenimageorigin.com/image/add6be0cef344e338de8bbe4ffea66c7.jpeg', // BLACKPINK
    'shinee': 'https://viki.rakutenimageorigin.com/image/8ee00b36a66f4fec8ebae240373fdcbc.jpeg', // SHINee
    'girls-generation': 'https://viki.rakutenimageorigin.com/image/e6b2d51f3f0e4ceda6f7d62d07008410.jpeg', // Girls' Generation
    'dreamcatcher': 'https://viki.rakutenimageorigin.com/image/d25bdcdaf7b247e8bda3ec7e8138179e.jpeg', // Dreamcatcher

    // DEFAULT
    'default': 'https://viki.rakutenimageorigin.com/image/0f824ec51432435a8a58fc2aa10e4e41.jpeg'
  },
  es: {
    // DEFAULT
    'default': 'https://viki.rakutenimageorigin.com/image/0f824ec51432435a8a58fc2aa10e4e41.jpeg'
  }
}



// WEBPACK FOOTER //
// ./assets/js/config/ImageBanner.js